export const theme = {
  colors: {
    black: '#000',
    white: '#fff',
    input: '#E0E0E0',
    background: '#fff',
    primary: '#212121',
    secondary: '#9B9FAA',
    accent: '#FC842D',
    count: '#264061',
    error: '#FF0000',
    track: '#F0F1F3',
  },
  space: [0, 2, 4, 8, 16, 32, 64, 128, 256],
  spaceForm: [13, 20, 40, 60, 160],
  fonts: {
    body: 'system-ui, sans-serif',
    heading: 'system-ui, sans-serif',
    monospace: 'Menlo, monospace',
  },
  fontSizes: {
    xs: '14px',
    s: '18px',
    m: '24px',
    l: '26px',
    xl: '34px',
    xxl: '48px',
  },
  fontWeights: {
    normal: 400,
    bold: 700,
  },
  lineHeights: {
    body: 1.5,
    heading: 1.125,
  },
  borders: {
    none: 'none',
    normal: '1px solid',
  },
  radii: {
    none: '0',
    sm: '4px',
    md: '8px',
    lg: '16px',
    button: '30px',
    round: '50%',
  },
  breakpoints: {
    xxs: '0',
    ss: '320',
    mm: '768px',
    ll: '1280px',
  },
};
